<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" ref="order_number" @ok="ok"
           :title="$t(title)" :ok-disabled="isLoading" :cancel-disabled="isLoading"
           :bookingId="bookingId"
  >
    <frontoffice-loader v-if="isLoading && !displayError" />

    <div v-else>
      <text-input :required="true" :name="id" :label="labels.orderNumber"
                  v-model="submitterInfos.values.get('orderNumber')" @input="setOrderNumber"  :state="state" :help="getHelpMessage()"
                  :mask="mask"

      />

      <file-input :types="fileTypes" ref="pdf" :label="labels.pdf"
                  v-model="submitterInfos.values.get('pdf')" @input="setPdf"
      />

      <b-alert v-if="displayError" variant="danger" show class="col-12">
        <div v-for="msg in errorMessages">
          <span v-if="msg.field">{{ msg.field }} : </span>
          <span>{{ msg.value }}</span>
        </div>
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
import textInput from '@/components/frontoffice/form/baseInput/text'
import fileInput from '@/components/frontoffice/form/baseInput/file'
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import frontofficeLoader from '@/components/frontoffice/loader'
import FormSubmitter from '@/api/formSubmitter'

export default {
  components: {
    textInput,
    fileInput,
    frontofficeLoader
  },

  mixins: [modalMixin],

  props: {
    id: {
      type: String,
      default: 'order_number'
    },
    bookingId: Number
  },

  data () {
    return {
      isLoading: false,
      submitterInfos: {
        type: 'order_number',
        values: new FormData()
      },
      displayError: false,
      errorMessages: [],
      closeAfterServerResponse: true,
      title: 'booking.orderNumber.title',
      company: null,
      mask: '',
      regExp: '',
      pattern: '',
      state: null
    }
  },

  created () {
    this.company = this.$store.getters['security/company']
    this.patternToMask()
    this.regExp = this.company.orderNumber.regex
    this.submitterInfos.values.set('orderNumber', '')
  },

  methods: {
    setPdf (file) {
      this.submitterInfos.values.set('pdf', file)
    },

    setOrderNumber (orderNumber) {
      this.submitterInfos.values.set('orderNumber', orderNumber)
    },

    ok (event) {
      event.preventDefault()
      this.isLoading = true
      this.displayError = false
      const testRegEx = new RegExp(this.regExp)
      const orderNumber = this.submitterInfos.values.get('orderNumber').trim()
      this.submitterInfos.values.set('orderNumber', orderNumber)
      if (testRegEx.test(orderNumber) && !!orderNumber) {
        this.state = true
        this.confirm()
      } else {
        this.state = false
        this.errorMessages = []
        this.displayError = true
        this.isLoading = false
        this.errorMessages.push({ value: this.$t('booking.orderNumber.wrongValue') })
      }
    },

    confirm () {
      const submitter = new FormSubmitter('order_number')
      submitter.submitRequest(this.submitterInfos.values, this.bookingId)
        .then(response => {
          if (response.data.success) {
            this.dealSuccess()
          } else {
            this.dealFailure(response.data.errors)
          }
        })
    },

    dealFailure (errors) {
      this.setErrorMessages(errors)
    },

    setErrorMessages (msgs) {
      this.errorMessages = []
      this.displayError = true
      this.isLoading = false
      if (msgs) {
        Object.keys(msgs).forEach(key => {
          let field = key === 'orderNumber'
            ? this.$t(this.label)
            : 'PDF'

          this.errorMessages.push({
            field: field,
            value: this.$t(`error.${msgs[key]}`)
          })
        })
      } else {
        this.errorMessages.push({ value: this.$t('booking.orderNumber.noValue') })
      }
    },

    reset () {
      this.submitterInfos.values.set('orderNumber', '')
      this.submitterInfos.values.set('pdf', null)
      this.isLoading = false
      this.displayError = false
    },
    patternToMask () {
      if (this.company.orderNumber.required) {
        this.pattern = this.company.orderNumber.pattern ? this.company.orderNumber.pattern : ''
        if (!this.pattern.includes('+')) {
          this.mask = this.pattern
        }
      }
    },
    getHelpMessage () {
      if (this.pattern === '') {
        return "Votre entreprise n'a pas de modèle renseigné."
      }

      return 'Votre modèle : ' + this.pattern + "    [ ? pour une lettre /  # pour un chiffre /  + pour une répétition allant de 1 à l'infini du caractère précédent ]"
    }
  },

  computed: {
    successMessage () {
      let orderNumber = this.submitterInfos.values.orderNumber

      return this.$t('booking.orderNumber.success', { ref: orderNumber })
    },

    labels () {
      return {
        orderNumber: this.$store.getters['security/company'].orderNumber.label ||
          this.$t('company.orderNumber.title'),
        pdf: this.$t('booking.orderNumber.addPdf')
      }
    },

    fileTypes () {
      return this.$store.getters['security/files']['orderNumber']['mime'].join()
    }
  },

  watch: {
    isLoading (val) {
      this.title = val ? '' : 'booking.orderNumber.title'
    }
  }
}
</script>

<style lang="scss">
  #order_number {
    .custom-file-label {
      overflow: hidden;
    }
  }
</style>
